import { orchestrator } from 'satcheljs';
import { loadSavedCalendarViews } from '../actions/publicActions';
import { isStoreLoaded } from '../selectors/saveCalendarViewDataSelectors';
import { getSavedCalendarViewsService } from '../services/getSavedCalendarViewsService';
import { updateStoreFromOws } from '../mutators/updateStoreFromOwsMutator';
import * as trace from 'owa-trace';
import { createRetriableFunction, createExponentialBackoffFunction } from 'owa-retriable-function';
import { logSaveViewsApiFailure } from '../utils/logServiceResponseUtil';
import { GetSavedCalendarViewsResponse } from '../store/schema/SaveCalendarViewConfig';

export const createRetriableFunc = createRetriableFunction({
    maximumAttempts: 3,
    timeBetweenRetryInMS: createExponentialBackoffFunction(1000),
});

let currentRequest: {
    retriableFunc: () => Promise<GetSavedCalendarViewsResponse>;
    cancel: () => void;
} | null = null;

export const loadSavedCalendarViewsOrchestrator = orchestrator(loadSavedCalendarViews, async () => {
    if (!isStoreLoaded()) {
        try {
            if (currentRequest) {
                currentRequest.cancel();
            }
            currentRequest = createRetriableFunc(() => getSavedCalendarViewsService());
            let response = await currentRequest.retriableFunc();
            if (response?.savedViews) {
                updateStoreFromOws(response.savedViews);
            } else {
                logSaveViewsApiFailure('get');
            }
        } catch (error) {
            trace.errorThatWillCauseAlert(
                'getSavedCalendarViewsService: failed to get saved views from service',
                error
            );
        }
    }
});
